export const REFRESH_ADS_REQUESTED = 'REFRESH_ADS_REQUESTED';
export const REFRESH_ADS_SUCCESS = 'REFRESH_ADS_SUCCESS';
export const REFRESH_ADS_FAILED = 'REFRESH_ADS_FAILED';
export const FETCH_ADS_REQUESTED = 'FETCH_ADS_REQUESTED';
export const FETCH_ADS_SUCCESS = 'FETCH_ADS_SUCCESS';
export const FETCH_ADS_FAILED = 'FETCH_ADS_FAILED';

export const REVIEW_AUDIO_ADS_REQUESTED = 'REVIEW_AUDIO_ADS_REQUESTED';
export const REVIEW_AUDIO_ADS_SUCCESS = 'REVIEW_AUDIO_ADS_SUCCESS';
export const REVIEW_AUDIO_ADS_FAILED = 'REVIEW_AUDIO_ADS_FAILED';

export const UPDATE_PAGING_INFO = 'UPDATE_PAGING_INFO';
export const UPDATE_REVIEW_AUDIO_PAGING_INFO = 'UPDATE_REVIEW_AUDIO_PAGING_INFO';
export const UPDATE_NAME_FILTER = 'UPDATE_NAME_FILTER';

export const FETCH_AD_REQUESTED = 'FETCH_AD_REQUESTED';
export const FETCH_AD_SUCCESS = 'FETCH_AD_SUCCESS';
export const FETCH_AD_FAILED = 'FETCH_AD_FAILED';
export const FETCH_AD_NOT_FOUND = 'FETCH_AD_NOT_FOUND';
export const ACTIVE_STATUS_FILTER_UPDATED = 'ACTIVE_STATUS_FILTER_UPDATED';

export const APPROVE_AD_SUBMITTED = 'APPROVE_AD_SUBMITTED';
export const APPROVE_AD_SUCCEEDED = 'APPROVE_AD_SUCCEEDED';
export const APPROVE_AD_FAILED = 'APPROVE_AD_FAILED';
export const APPROVE_AD_PROMPTED = 'APPROVE_AD_PROMPTED';

export const REJECT_AD_SUBMITTED = 'REJECT_AD_SUBMITTED';
export const REJECT_AD_SUCCEEDED = 'REJECT_AD_SUCCEEDED';
export const REJECT_AD_FAILED = 'REJECT_AD_FAILED';
export const REJECT_AD_PROMPTED = 'REJECT_AD_PROMPTED';

export const REVISE_AD_SUCCEEDED = 'REVISE_AD_SUCCEEDED';
export const REVISE_AD_FAILED = 'REVISE_AD_FAILED';
export const REVISE_AD_PROMPTED = 'REVISE_AD_PROMPTED';

export const REVISE_VO_SUBMITTED = 'REVISE_VO_SUBMITTED';
export const REVISE_BG_SUBMITTED = 'REVISE_BG_SUBMITTED';

export const CANCEL_AD_SUBMITTED = 'CANCEL_AD_SUBMITTED';
export const CANCEL_AD_SUCCEEDED = 'CANCEL_AD_SUCCEEDED';
export const CANCEL_AD_FAILED = 'CANCEL_AD_FAILED';

export const KICK_AD_SUBMITTED = 'KICK_AD_SUBMITTED';
export const KICK_AD_SUCCEEDED = 'KICK_AD_SUCCEEDED';
export const KICK_AD_FAILED = 'KICK_AD_FAILED';

export const RECEIVE_AD = 'RECEIVE_AD';

export function refreshAds(params, wgToken) {
  return {
    type: REFRESH_ADS_REQUESTED,
    payload: {
      params,
      wgToken,
    },
  };
}

export function fetchReviewAudioAds(params, wgToken) {
  return {
    type: REVIEW_AUDIO_ADS_REQUESTED,
    payload: {
      params,
      wgToken,
    },
  };
}

export function fetchAds(offset, limit, wgToken) {
  return {
    type: FETCH_ADS_REQUESTED,
    payload: {
      offset,
      limit,
      wgToken,
    },
  };
}

export function fetchAd(id, wgToken) {
  return {
    type: FETCH_AD_REQUESTED,
    payload: {
      id,
      wgToken,
    },
  };
}

export function fetchAdFailed(err) {
  return {
    type: FETCH_AD_FAILED,
    err,
  };
}


export function fetchAdNotFound(err) {
  return {
    type: FETCH_AD_NOT_FOUND,
    err,
  };
}

export function fetchAdSuccess(ad) {
  return {
    type: FETCH_AD_SUCCESS,
    ad,
  };
}

export function fetchAdsFailed(err) {
  return {
    type: FETCH_ADS_FAILED,
    err,
  };
}

export function refreshAdsFailed(err) {
  return {
    type: REFRESH_ADS_FAILED,
    err,
  };
}

export function reviewAudioAdsFailed(err) {
  return {
    type: REVIEW_AUDIO_ADS_FAILED,
    err,
  };
}

export function fetchAdsSuccess(ads) {
  return {
    type: FETCH_ADS_SUCCESS,
    ads,
  };
}

export function refreshAdsSuccess(ads) {
  return {
    type: REFRESH_ADS_SUCCESS,
    ads,
  };
}

export function reviewAudioAdsSuccess(ads) {
  return {
    type: REVIEW_AUDIO_ADS_SUCCESS,
    ads,
  };
}

export function updatePagingInfo(paging) {
  return {
    type: UPDATE_PAGING_INFO,
    paging,
  };
}

export function updateReviewAudioPagingInfo(paging) {
  return {
    type: UPDATE_REVIEW_AUDIO_PAGING_INFO,
    paging,
  };
}

export function filterAdsByName(pattern) {
  return {
    type: UPDATE_NAME_FILTER,
    pattern,
  };
}

export function approveAd(id) {
  return {
    type: APPROVE_AD_SUBMITTED,
    id,
  };
}

export function approveAdSuccess(id) {
  return {
    type: APPROVE_AD_SUCCEEDED,
    id,
  };
}

export function approveAdFailed(err, id) {
  return {
    type: APPROVE_AD_FAILED,
    err,
    id,
  };
}

export function reviseVO(id, reviseVOInstructions) {
  return {
    type: REVISE_VO_SUBMITTED,
    id,
    reviseVOInstructions,
  };
}

export function reviseBGMusic(id, bgAssetId) {
  return {
    type: REVISE_BG_SUBMITTED,
    id,
    bgAssetId,
  };
}

export function reviseAdSuccess(id) {
  return {
    type: REVISE_AD_SUCCEEDED,
    id,
  };
}

export function reviseAdFailed(err, id) {
  return {
    type: REVISE_AD_FAILED,
    err,
    id,
  };
}

export function rejectAd(id, reason) {
  return {
    type: REJECT_AD_SUBMITTED,
    id,
    reason,
  };
}

export function rejectAdSuccess(id) {
  return {
    type: REJECT_AD_SUCCEEDED,
    id,
  };
}

export function rejectAdFailed(err, id) {
  return {
    type: REJECT_AD_FAILED,
    err,
    id,
  };
}

export function rejectAdPrompted(id) {
  return {
    type: REJECT_AD_PROMPTED,
    id,
  };
}

export function cancelAd(id) {
  return {
    type: CANCEL_AD_SUBMITTED,
    id,
  };
}

export function cancelAdSuccess(id) {
  return {
    type: CANCEL_AD_SUCCEEDED,
    id,
  };
}

export function cancelAdFailed(err, id) {
  return {
    type: CANCEL_AD_FAILED,
    err,
    id,
  };
}

export function kickAd(id) {
  return {
    type: KICK_AD_SUBMITTED,
    id,
  };
}

export function kickAdSuccess(id) {
  return {
    type: KICK_AD_SUCCEEDED,
    id,
  };
}

export function kickAdFailed(err, id) {
  return {
    type: KICK_AD_FAILED,
    err,
    id,
  };
}

export function triggerPrompt(id, type) {
  return {
    type,
    id,
  };
}

export function setActiveAdStatus(status) {
  return {
    type: ACTIVE_STATUS_FILTER_UPDATED,
    status,
  };
}



// WEBPACK FOOTER //
// ./src/actions/adReview.js